import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_MovToGifConverter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/mov-to-gif-converter',
			name: 'MOV to GIF Converter Online — Create Animated GIFs Instantly by Lift',
			description:
				'Convert MOV to GIF online — upload your MOV file and Lift turns it into an animated GIF in seconds. Perfect for sharing, no software needed. Try Lift now!',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/mov-to-gif-converter#product' },
				{ '@id': 'https://liftapp.ai/mov-to-gif-converter#howto' },
				{ '@id': 'https://liftapp.ai/mov-to-gif-converter#faq' },
				{ '@id': 'https://liftapp.ai/mov-to-gif-converter#why-lift' },
				{ '@id': 'https://liftapp.ai/mov-to-gif-converter#explore-tools' },
				{ '@id': 'https://liftapp.ai/mov-to-gif-converter#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/mov-to-gif-converter#product',
			name: 'MOV to GIF Converter Online',
			description:
				'Turn MOV videos into animated GIFs. Upload your MOV file, choose GIF as output, and download a shareable animated GIF in seconds.',
			url: 'https://liftapp.ai/mov-to-gif-converter',
			fileFormat: [
				'image/gif',
				'video/quicktime',
				'video/mp4',
				'video/x-msvideo',
				'video/webm',
				'video/x-matroska',
			],
			memoryRequirements: 'Max file size: 2GB',
			brand: { '@type': 'Brand', name: 'Lift' },
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/mov-to-gif-converter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload Your MOV File',
					text: 'Drop in your MOV file or any other supported video format — MP4, AVI, MKV, WEBM, FLV, and more.',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Choose GIF as Output',
					text: 'Select GIF from dozens of video and image output formats — MP4, WEBM, MOV, APNG, and more are also available.',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Lift Converts the Video',
					text: 'Lift processes your MOV and renders a smooth, full-color animated GIF optimized for size and quality.',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download the GIF',
					text: 'Your animated GIF is ready instantly — download it for sharing on social media, messaging apps, presentations, or websites.',
				},
			],
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/mov-to-gif-converter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is the Lift MOV to GIF Converter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift MOV to GIF Converter is an online tool that turns MOV video files into animated GIFs in seconds. Upload your MOV file, choose GIF as output, and download a shareable animated GIF.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does the Lift MOV to GIF Converter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Upload your MOV file, select GIF as the output format, and Lift processes the conversion. Your animated GIF is ready to download in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'How long does MOV to GIF conversion take?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Most conversions complete in seconds. Processing time depends on file length and size, but Lift is optimized to deliver results as fast as possible.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will the GIF look good from a MOV file?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift optimizes the GIF rendering for smooth animation and color accuracy. Results look great for social sharing, messaging, and web use.',
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe to convert files with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift prioritizes your privacy — all files are processed securely and are not stored or shared after conversion. Your converted result is available only to you.',
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/mov-to-gif-converter#why-lift',
			name: "Why Lift's MOV to GIF Converter stands out",
			description:
				'Smooth GIF output, intelligent frame optimization, cross-platform support, and budget-friendly pricing — Lift delivers professional-grade conversion.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Smooth animated GIFs',
					description:
						'AI-powered rendering delivers fluid, full-color GIFs optimized for sharing.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent frame optimization',
					description:
						'AI balances frame rate and file size for the best GIF output.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description:
						'Available on iOS, Android, and Web for seamless access.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly software with an affordable and intuitive tool.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/images/mov-to-gif-converter/whyLift.webp',
				name: 'Lift MOV to GIF Converter creating smooth animated GIFs',
				description: "Lift's online MOV to GIF converter in high resolution.",
			},
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/mov-to-gif-converter#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/mov-to-gif-converter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'MOV to GIF Converter',
					item: 'https://liftapp.ai/mov-to-gif-converter',
				},
			],
		},
	],
};
